<template>
  <div class="tools02-resend-offline-conversions">
    <el-row>
      <el-col>
        <ResendGoogleOfflineConversions />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ResendGoogleOfflineConversions from "@/components/Tools02/ResendOfflineConversions/ResendGoogleOfflineConversions.vue";

export default {
  components: {
    ResendGoogleOfflineConversions,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rt", "tool"]),
  },
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
